import { z } from "zod";
/** Linked messaging channels (block 24). */
/** `POST /v1/channels/link-code` → 201. `url` is the `wa.me` link the QR encodes (A5 C9). */
export const linkCodeResponseSchema = z.object({
    code: z.string().regex(/^[A-Z0-9]{6}$/),
    expiresAt: z.iso.datetime(),
    url: z.url(),
});
/** `phoneHint` is the last 4 digits. The number itself is only ever stored as an HMAC. */
export const linkedChannelSchema = z.object({
    id: z.uuid(),
    channelType: z.literal("whatsapp"),
    linkedAt: z.iso.datetime(),
    phoneHint: z.string().nullable(),
});
/** `GET /v1/channels`. `available`: can this deployment link WhatsApp at all (`true` from an older API). */
export const linkedChannelListSchema = z.object({ items: z.array(linkedChannelSchema), available: z.boolean().default(true) });
//# sourceMappingURL=channel.js.map